import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { resolve } from 'inversify-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { RegionListView } from './region-list.view';
import { RegionListDataService } from './region-list.data';

@observer
export class RegionListController extends React.Component<ControllerProps<{}>, {}> {
	@resolve
	toast: ToastNotifications;

	@observable
	dataService: RegionListDataService;

	constructor(props: Readonly<ControllerProps<{}>>) {
		super(props);
	}

	componentDidMount() {
		this.props.setBusy(true);
		this.loadData()
			.catch((error) => {
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			})
			.then(() => {
				this.props.setBusy(false);
			});
	}

	private async loadData(): Promise<void> {
		this.dataService = RegionListDataService.make();

		this.dataService.addSorting('id', 'asc', true);
		this.dataService.addFilter('isDeleted', 'eq', false);
		await this.dataService.load(query => query);
	}

	handleItemDoubleClick = (item?: RegionSummary) => {
		this.props.history.push(`/general/regions/${item == null ? 'new' : item.id}`);
	}

	render() {
		if (this.dataService == null || this.dataService.items == null) {
			return null;
		}

		return (
			<RegionListView
				model={this.dataService}
				setBusy={this.props.setBusy}
				onItemDoubleClicked={this.handleItemDoubleClick}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/regions/list/region-list.controller.tsx